import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const DEFAULT_DAYS = 30;

export function useReportingApiUsageUrlParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const days = useMemo(() => {
    const raw = searchParams.get('days');
    if (!raw) {
      return DEFAULT_DAYS;
    }
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? Math.max(1, Math.min(parsed, 90)) : DEFAULT_DAYS;
  }, [searchParams]);

  const selectedClientId = searchParams.get('client') ?? undefined;
  const errorCode = searchParams.get('error_code') ?? undefined;

  const setDays = useCallback((nextDays: number) => {
    setSearchParams((current) => {
      const params = new URLSearchParams(current);
      params.set('days', String(nextDays));
      return params;
    }, { replace: true });
  }, [setSearchParams]);

  const setSelectedClientId = useCallback((clientId?: string) => {
    setSearchParams((current) => {
      const params = new URLSearchParams(current);
      if (clientId) {
        params.set('client', clientId);
      } else {
        params.delete('client');
      }
      return params;
    }, { replace: true });
  }, [setSearchParams]);

  const setErrorCode = useCallback((code?: string) => {
    setSearchParams((current) => {
      const params = new URLSearchParams(current);
      if (code) {
        params.set('error_code', code);
      } else {
        params.delete('error_code');
      }
      return params;
    }, { replace: true });
  }, [setSearchParams]);

  return {
    days,
    selectedClientId,
    errorCode,
    setDays,
    setSelectedClientId,
    setErrorCode,
  };
}
